export * from './setting.module';

export { SettingComponent } from './setting.component';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/setting/index.ts